module.exports = __webpack_public_path__ + "img/Frame.52c006b5.png";